import { convertArray, templateParseToElement } from "@bonusmap/shared_ui/library";
import { BonusCategories } from "../bonus-categories/bonus-categories";
import { DataBaseComponent } from "./data-base-component";

export class DataCategoriesComponent extends DataBaseComponent {
    static webComponentName: string = "data-categories";
    protected _templateId: string = "data-categories-component"; // Template ID for rendering
    protected inputType: string = "text"; // Default input type for categories fields
    protected categoriesComponent: BonusCategories | null = null; // Reference to the categories input component
    protected rendered: boolean = false
    get value(): any {
        let outputValue= super.value;
        if (this.categoriesComponent && this.rendered) {
            
            outputValue = this.categoriesComponent.value;
        }
        if( Array.isArray(outputValue)) {
            outputValue = convertArray(outputValue, 'number');
        }
        return outputValue;
    }
    set value(newValue: any) {
        super.value = newValue;
    }
    constructor() {
        super();
    }
    addDataForTemplate(): Record<string, any> {
        const initialValue = Array.isArray(this.value) ? this.value.join(', ') : '';

        return {
            inputType: this.inputType, // Pass the input type to the template
            field: this.field, // Include field metadata
            readonly: this.readOnly, // Pass readOnly state
            initialValue
        };
    }
    protected afterRender(): void {
        super.afterRender();
        this.categoriesComponent = this.querySelector<BonusCategories>('bonus-categories');
        if (this.categoriesComponent) {
            this.rendered = true;
        }
    }
    protected render(): void {
        templateParseToElement(this.templateId, this, this.addDataForTemplate());
        this.afterRender();
    }
}